export const FORCED_MOBILE_QUERY_PARAM = 'forcedMobile';
export const FORCED_MOBILE_HEADER = 'x-forced-mobile';
export const FORCED_MOBILE_COOKIE = 'safeon_forced_mobile';
export const SAFEON_CLIENT_QUERY_PARAM = 'safeonClient';
export const SAFEON_PLATFORM_QUERY_PARAM = 'safeonPlatform';
export const SAFEON_CLIENT_HEADER = 'x-safeon-client';
export const SAFEON_PLATFORM_HEADER = 'x-safeon-platform';
export const SAFEON_CLIENT_COOKIE = 'safeon_client';
export const SAFEON_PLATFORM_COOKIE = 'safeon_platform';
export const SAFEON_FLUTTER_CLIENT = 'safeon_flutter_app';
export const SAFEON_PLATFORMS = ['ios', 'android'] as const;

export type SafeonPlatform = (typeof SAFEON_PLATFORMS)[number];
type SafeonSearchSource = URLSearchParams | Pick<URLSearchParams, 'get'> | Record<string, string | string[] | null | undefined>;

function hasSearchParamGetter(source: SafeonSearchSource): source is Pick<URLSearchParams, 'get'> {
  return typeof (source as Pick<URLSearchParams, 'get'>).get === 'function';
}

export function isForcedMobileValue(value: string | null | undefined) {
  return value === 'true';
}

export function isForcedMobileSearch(search: string) {
  return isForcedMobileValue(new URLSearchParams(search).get(FORCED_MOBILE_QUERY_PARAM));
}

export function isSafeonFlutterClient(value: string | null | undefined) {
  return value === SAFEON_FLUTTER_CLIENT;
}

export function isSafeonPlatform(value: string | null | undefined): value is SafeonPlatform {
  return SAFEON_PLATFORMS.includes(value as SafeonPlatform);
}

function readSafeonSearchValue(source: SafeonSearchSource, name: string) {
  if (hasSearchParamGetter(source)) {
    return source.get(name);
  }

  const value = source[name];
  return Array.isArray(value) ? value[0] : value;
}

export function appendSafeonSearchParams(url: string, source: SafeonSearchSource) {
  const forcedMobile = readSafeonSearchValue(source, FORCED_MOBILE_QUERY_PARAM);
  const safeonClient = readSafeonSearchValue(source, SAFEON_CLIENT_QUERY_PARAM);
  const safeonPlatform = readSafeonSearchValue(source, SAFEON_PLATFORM_QUERY_PARAM);

  if (!isForcedMobileValue(forcedMobile) && !isSafeonFlutterClient(safeonClient) && !isSafeonPlatform(safeonPlatform)) {
    return url;
  }

  const hashIndex = url.indexOf('#');
  const urlWithoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
  const queryIndex = urlWithoutHash.indexOf('?');
  const pathname = queryIndex >= 0 ? urlWithoutHash.slice(0, queryIndex) : urlWithoutHash;
  const search = queryIndex >= 0 ? urlWithoutHash.slice(queryIndex + 1) : '';
  const params = new URLSearchParams(search);

  if (isForcedMobileValue(forcedMobile)) {
    params.set(FORCED_MOBILE_QUERY_PARAM, 'true');
  }
  if (isSafeonFlutterClient(safeonClient)) {
    params.set(SAFEON_CLIENT_QUERY_PARAM, safeonClient);
  }
  if (isSafeonPlatform(safeonPlatform)) {
    params.set(SAFEON_PLATFORM_QUERY_PARAM, safeonPlatform);
  }

  const nextSearch = params.toString();
  return nextSearch ? `${pathname}?${nextSearch}${hash}` : `${pathname}${hash}`;
}
